'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _uvdomReact = require('uvdom/react');

var _uvdomBootstrap = require('uvdom-bootstrap');

var _uvdomBootstrap2 = _interopRequireDefault(_uvdomBootstrap);

function create() {
  var overrides = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  function struct(locals) {
    var children = [];

    if (locals.help) {
      children.push(struct.renderHelp(locals));
    }

    if (locals.error && locals.hasError) {
      children.push(struct.renderError(locals));
    }

    children = children.concat(locals.order.map(function (name) {
      return locals.inputs[name];
    }));

    return struct.renderFieldset(children, locals);
  }

  struct.renderHelp = overrides.renderHelp || function renderHelp(locals) {
    return _uvdomBootstrap2['default'].getAlert({
      children: locals.help
    });
  };

  struct.renderError = overrides.renderError || function renderError(locals) {
    return _uvdomBootstrap2['default'].getAlert({
      type: 'danger',
      children: locals.error
    });
  };

  struct.renderFieldset = overrides.renderFieldset || function renderFieldset(children, locals) {
    var _className;

    var len = locals.path.length;
    var className = (_className = {
      fieldset: true
    }, _className['fieldset-depth-' + len] = true, _className);
    if (len > 0) {
      className['fieldset-' + locals.path.join('-')] = true;
    }
    if (locals.className) {
      className[locals.className] = true;
    }
    return _uvdomBootstrap2['default'].getFieldset({
      className: className,
      disabled: locals.disabled,
      legend: locals.label,
      children: children
    });
  };

  struct.clone = function clone() {
    var newOverrides = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    return create(_extends({}, overrides, newOverrides));
  };

  struct.toReactElement = _uvdomReact.compile;

  return struct;
}

exports['default'] = create();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/tcomb-form/lib/templates/bootstrap/struct.js
// module id = 589
// module chunks = 0 1 2